<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal';
import DatePicker from "vue2-datepicker";
import moment from "moment";
import pdf from 'vue-pdf'
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker, pdf },
    data() {
        return {
            title: "Agregar Gasto Asociado",
            items: [
                {
                text: "Gastos",
                href: "/web/reembolsos/ver_reembolsos"
                },
                {
                text: "Agregar Gasto",
                active: true
                }
            ],
            eventos:[],
            colegios:[],
            tipos:['Transporte local/Nacional','Transporte Uber','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Viajes Aereos'],
            gasto:{
                evento:'',
                tipo:'',
                monto:'$0',
                imagen:[],
                fecha:'',
                colegio:''
            },
            file: null,
            imagenminiatura:'',
            colegiosFiltrados:[],
            eventoscolegiosFiltrados:[],
            eventosFiltrados:[],
            archivoPreview: '',
            tipoArchivo: ''
        };
    },
    computed: {
        imagen(){
        return this.imagenminiatura;
        },
        busqueda(){
            if (this.gasto.fecha=='') {
                return true;
            }else{
                return false;
            }
        },
        bus_even(){
            if (this.gasto.colegio=='') {
                return true;
            }else{
                return false;
            }
        }
    },
    methods:{
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        labelColegio(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        format_Valor(){
            this.gasto.monto=this.format_Valor_variable(this.gasto.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        obtenerImagen(e){
            let file = e.target.files[0];
            if (!file) return;
            this.gasto.imagen = file;
            this.cargarImagen(file);
        },
        cargarImagen(file){
            let reader = new FileReader();
            // Verificar el tipo de archivo
            if (file.type.includes("image")) {
                this.tipoArchivo = "imagen";
            } else if (file.type.includes("pdf")) {
                this.tipoArchivo = "pdf";
            } else {
                this.tipoArchivo = "";
                return;
            }
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        guardar(){
            let formData = new FormData();
            formData.append('evento_id', this.gasto.evento.id);
            formData.append('fecha', this.gasto.fecha);
            formData.append('tipo', this.gasto.tipo);
            formData.append('monto', this.gasto.monto);
            formData.append('imagen', this.gasto.imagen);
            formData.append('coordinador_id', this.gasto.evento.coordinador_evento);
            axios.post('/api/agregar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.gasto.fecha='';
                    this.gasto.colegio='';
                    this.gasto.evento='';
                    this.gasto.tipo='';
                    this.gasto.monto='$0';
                    this.gasto.imagen=[];
                    this.imagenminiatura='';
                    this.tipoArchivo='';
                    this.msg('success','Gasto agregado correctamente');
                }else{
                    this.msg('error','Gasto No agregado');
                }
            });
        },
        validaciones(){
            if(this.gasto.fecha=='' || this.gasto.fecha==null){
                this.msg('error','Falta campo por completar','Fecha');
                return
            }
            if(this.gasto.colegio=='' || this.gasto.colegio==null){
                this.msg('error','Falta campo por completar','Colegio');
                return
            }
            if(this.gasto.evento=='' || this.gasto.evento==null){
                this.msg('error','Falta campo por completar','Evento');
                return
            }
            if(this.gasto.tipo=='' || this.gasto.tipo==null){
                this.msg('error','Falta campo por completar','Tipo');
                return
            }
            if(this.gasto.monto=='' || this.gasto.monto==null){
                this.msg('error','Falta campo por completar','Monto');
                return
            }
            if(this.gasto.imagen=='' || this.gasto.imagen==null || this.gasto.imagen.length<=0){
                this.msg('error','Falta campo por completar','Documento');
                return
            }
            this.guardar();
        },
        msg(tipo,titulo,frase){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: frase,
                showConfirmButton: false,
                timer: 5000
            });
        },
        filtro_colegios() {
            if (!this.gasto.fecha) return;
            // Filtrar eventos por la fecha seleccionada
            this.eventoscolegiosFiltrados = this.eventos.filter(
                (evento) => moment(evento.fecha_inicio).format('YYYY-MM-DD') === this.gasto.fecha
            );
            // Extraer RBD únicos y normalizarlos numéricamente cuando sea posible
            const rbdUnicos = [...new Set(this.eventoscolegiosFiltrados.map(evento => {
                const n = Number(evento.rbd_colegio);
                return isNaN(n) ? String(evento.rbd_colegio).trim() : n;
            }))];
            // Filtrar colegios con los RBD obtenidos (comparación numérica preferente)
            this.colegiosFiltrados = this.colegios.filter(colegio => {
                const rbdNum = Number(colegio.rbd);
                if (!isNaN(rbdNum)) {
                    return rbdUnicos.includes(rbdNum);
                }
                return rbdUnicos.includes(String(colegio.rbd).trim());
            });
        },
        filtro_eventos(){
            this.eventosFiltrados = this.eventoscolegiosFiltrados.filter(
                (evento) => evento.rbd_colegio == this.gasto.colegio.rbd
            );
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today ;
        },
    },
    created(){
        axios.get('/api/get_eventos').then(res=>{
            //this.eventos=res.data.eventos
            this.eventos = res.data.eventos.filter(evento => new Date(evento.fecha_inicio) <= new Date());
        });
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.colegios = response.data.colegios;
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-plus-circle font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Agregar Gasto Asociado</h5>
                            <small class="text-white" style="opacity:.8;">Registra un gasto asociado a un evento</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Fecha:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <date-picker v-model="gasto.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" :disabled-date="disabledBeforeToday" @change="filtro_colegios"></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Colegio:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.colegio"
                                            :options="colegiosFiltrados"
                                            placeholder="Seleccionar colegio"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelColegio"
                                            :disabled="busqueda"
                                            @select="filtro_eventos"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Evento:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.evento"
                                            :options="eventosFiltrados"
                                            placeholder="Seleccionar evento"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelEvento"
                                            :disabled="bus_even"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Tipo de gasto:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.tipo"
                                            :options="tipos"
                                            placeholder="Seleccionar tipo"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Monto del Gasto:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-input v-model="gasto.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Documento Asociado:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-file
                                            v-model="gasto.imagen"
                                            class="form-control border-primary"
                                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                                            placeholder="Elegir Archivo"
                                            drop-placeholder="Arrastra el archivo aquí..."
                                            @change="obtenerImagen"
                                            browse-text="Examinar"
                                        ></b-form-file>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-right">
                                <b-button variant="primary" @click="validaciones">Guardar</b-button>
                            </div>
                            <div class="offset-md-1 col-md-10 text-center">
                                <!-- Mostrar imagen si el archivo es imagen -->
                                <figure v-if="tipoArchivo === 'imagen'">
                                    <img :src="imagenminiatura" height="400" alt="Imagen del producto">
                                </figure>
                                <!-- Mostrar PDF si el archivo es PDF -->
                                <div v-if="tipoArchivo === 'pdf'">
                                    <pdf :src="imagenminiatura"></pdf>
                                    <!-- <embed :src="imagenminiatura" type="application/pdf" width="100%" height="500px" /> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
